export default __webpack_public_path__ + "static/media/nodata.219fe4f6.svg";